module.exports = __webpack_public_path__ + "static/media/WhitneyCond-Light.d1e474f9.otf";